var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cars_compare__row"},[_c('div'),_vm._l((_vm.comparingItems),function(id,i){return _c('VehicleImage',{key:i + '-' + id,attrs:{"index":i,"id":id,"photo":_vm.photos[i],"url":_vm.urls[i]}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }